// libs
import React, { useEffect, useMemo, useState } from 'react';
import cx from 'classnames';
import dayjs from 'dayjs';
// widgets
import Table from '@/widgets/Table';
import DateRangeSelector from '../DateRangeSelector';
import CampaginsTablePlaceholder from '@/components/CampaignsTablePlaceholder/CampaginsTablePlaceholder';
// styles
import style from '@/widgets/Table/Table.module.scss';
import campaignTableStyle from './Table.module.scss';
import { AdvertiserDimensions } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
// constants
import { PERFORMANCE_SUMMARY_TABLE_COLUMNS } from '@/constants/Misc';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
const PerformanceSummaryTable = (props) => {
    const { performanceData: campaignPerformance, fetchMetrics } = props;
    const campaignData = useMemo(() => {
        var _a;
        return (_a = campaignPerformance.data) === null || _a === void 0 ? void 0 : _a.filter((item) => !!item.dimension[AdvertiserDimensions.DIMENSION_DAY]).map((item) => {
            var _a, _b;
            return {
                date: dayjs(item.dimension[AdvertiserDimensions.DIMENSION_DAY]).format('MMMM D, YYYY'),
                impressionCount: (_a = item.metrics.impressions) === null || _a === void 0 ? void 0 : _a.toString(),
                addToCart: (_b = item.metrics.addToCart) === null || _b === void 0 ? void 0 : _b.toString(),
                gmv: item.metrics.gmv.toFixed(2),
                roi: item.metrics.roi.toFixed(2),
            };
        });
    }, [campaignPerformance]);
    const [tableData, setTableData] = useState(campaignData);
    useEffect(() => {
        setTableData(campaignData);
    }, [campaignPerformance]);
    const handleTableSort = (sortData) => {
        const { sortBy, descending } = sortData;
        let sorted = [...tableData];
        switch (sortBy) {
            case 'dateRange':
                sorted = sorted.sort((a, b) => {
                    if (descending) {
                        return dayjs(b.date).diff(dayjs(a.date));
                    }
                    return dayjs(a.date).diff(dayjs(b.date));
                });
                break;
            case 'impressionCount':
            case 'addToCart':
            case 'gmv':
            case 'roi':
                sorted = sorted.sort((a, b) => {
                    if (descending) {
                        return Number(b[sortBy]) - Number(a[sortBy]);
                    }
                    return Number(a[sortBy]) - Number(b[sortBy]);
                });
                break;
            default:
                sorted = tableData;
        }
        setTableData(sorted);
    };
    const getText = (text) => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Med_Emphasis }, text));
    };
    const renderRow = (row, index) => {
        return (React.createElement("ul", { className: cx(style.tableRow, style.rowList), key: row.date },
            React.createElement("li", { style: {
                    width: PERFORMANCE_SUMMARY_TABLE_COLUMNS[0].width,
                }, className: campaignTableStyle.leftAligned }, getText(row.date)),
            React.createElement("li", { style: {
                    width: PERFORMANCE_SUMMARY_TABLE_COLUMNS[1].width,
                } }, getText(row.impressionCount)),
            React.createElement("li", { style: {
                    width: PERFORMANCE_SUMMARY_TABLE_COLUMNS[2].width,
                } }, getText(row.addToCart)),
            React.createElement("li", { style: {
                    width: PERFORMANCE_SUMMARY_TABLE_COLUMNS[3].width,
                } }, getText(row.gmv)),
            React.createElement("li", { style: {
                    width: PERFORMANCE_SUMMARY_TABLE_COLUMNS[4].width,
                } }, getText(row.roi))));
    };
    const renderPlaceholder = () => {
        return (React.createElement(CampaginsTablePlaceholder, { title: "No performance metrics", subTitle: "Your performance metrics will show here" }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Table, { classNames: { container: campaignTableStyle.table }, columns: PERFORMANCE_SUMMARY_TABLE_COLUMNS, data: tableData, renderRow: renderRow, onSort: handleTableSort, FirstColumn: DateRangeSelector, firstColumnProps: {
                onSelect: fetchMetrics,
                selectedRange: campaignPerformance.selectedRange,
            }, renderPlaceholder: renderPlaceholder })));
};
export default PerformanceSummaryTable;
